import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './../assets/portraits/sourire.jpg'


const _hoisted_1 = { class: "vue-container" }
const _hoisted_2 = {
  class: "presentation-title",
  id: "title-div"
}
const _hoisted_3 = {
  class: "presentation-container hide",
  id: "presentation-div"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "image-div" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "img-sizing"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-div" }, [
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createTextVNode(" Développeur web full stack, possédant 5 ans d’expérience PRO, qui m'ont apporté des compétences techniques, organisationnelles et humaines pour répondre au mieux aux besoins de réalisation et de développement d’applications orientées clients légers et mobiles ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right middle-right clickable" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        id: "title-text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fadeLeft()))
      }, "Développeur web full stack")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToCuriculumVitaePage()))
      }, _hoisted_7)
    ])
  ]))
}